import FullSizeImageModal from "./FullSizeImageModal";

export default FullSizeImageModal;
